import { IMMEDIATE_NURSE_CONSULT_SMS_LOCAL_STORAGE_KEY } from '@/constants/immediateNurseConsultation';
import { useSmsCountdown } from './useSmsVerificationTimer';

export const useSmsVerification = () => {
  const { millisecondsLeft, setCountdown } = useSmsCountdown(IMMEDIATE_NURSE_CONSULT_SMS_LOCAL_STORAGE_KEY);

  const startSmsVerificationCountdown = (retryAfterMs: number) => {
    setCountdown(retryAfterMs);
  };

  return {
    startSmsVerificationCountdown,
    millisecondsLeft,
  };
};
